// @ts-check
import React from "react"
import Card from "../../../../../components/atoms/Card.atom"
import Button from "../../../../../components/atoms/Button.atom"
import { getAgentToolDisplayLabel } from "./agentToolDisplayLabels"
import { ToolApprovalParamsPreview } from "./toolApprovalParamsPreview"
import { toolIdFromPart } from "./uiMessageParts"
import "../quick-v2/ApprovalDialog.css"

/**
 * @typedef {import("ai").ToolUIPart | import("ai").DynamicToolUIPart} ToolUIPartLike
 */

/**
 * @typedef {object} ToolApprovalCardProps
 * @property {ToolUIPartLike} part
 * @property {boolean} [busy]
 * @property {(approvalId: string, approved: boolean) => void} onDecision
 */

/**
 * @param {ToolApprovalCardProps} props
 */
export default function ToolApprovalCard({ part, busy = false, onDecision }) {
  const approvalId =
    part.state === "approval-requested" && "approval" in part ?
      part.approval.id
    : null
  if (!approvalId) return null

  const toolName = toolIdFromPart(part)
  const subtitle = toolName ? getAgentToolDisplayLabel(toolName) : null

  return (
    <Card className="approval-dialog estimation-agent-quick-v3__tool-approval-card">
      <div className="approval-header">
        <i className="pi pi-exclamation-circle approval-icon" aria-hidden />
        <h3 className="approval-title">AIKA necesita tu aprobación</h3>
      </div>

      <p className="approval-description">
        El agente quiere efectuar una acción pero es necesaria tu aprobación
        primero{subtitle ? ` · ${subtitle}` : ""}
      </p>

      <div className="approval-content">
        <ToolApprovalParamsPreview part={part} />
      </div>

      <div className="approval-actions">
        <Button
          type="button"
          label="Denegar"
          icon="pi pi-times"
          className="p-button-sm p-button-outlined p-button-danger"
          onClick={() => onDecision(approvalId, false)}
          disabled={busy}
        />
        <Button
          type="button"
          label="Aprobar"
          icon="pi pi-check"
          className="p-button-sm p-button-success"
          onClick={() => onDecision(approvalId, true)}
          disabled={busy}
          loading={busy}
        />
      </div>
    </Card>
  )
}
